import { useEffect, useMemo, useState } from 'react';
import { MOTIVISION_ADMINS } from '../constants';
import { useSessionData } from '../providers';
import { fetchAllGyms } from '../api/api-controllers/gyms-controller';
import type { Gym } from '../types';

export const useAdminGyms = () => {
  const { loginManager, gyms: sessionGyms } = useSessionData();
  const [allGyms, setAllGyms] = useState<Gym[]>([]);
  const isAdmin =
    !!loginManager && MOTIVISION_ADMINS.includes(loginManager.id ?? '');

  useEffect(() => {
    if (!isAdmin) {
      setAllGyms([]);
      return;
    }
    let mounted = true;
    fetchAllGyms().then((result) => {
      if (!mounted || !result.success || !result.data) {
        return;
      }
      setAllGyms(result.data);
    });
    return () => {
      mounted = false;
    };
  }, [isAdmin]);

  const gyms: Gym[] = useMemo(() => {
    if (!isAdmin) {
      return sessionGyms;
    }
    const gymsMap = new Map(allGyms.map((gym) => [gym.id, gym]));
    sessionGyms.forEach((gym) => {
      gymsMap.set(gym.id, gym);
    });
    return Array.from(gymsMap.values());
  }, [allGyms, isAdmin, sessionGyms]);

  return {
    gyms,
    isAdmin,
    isLoading: isAdmin && !allGyms.length,
  };
};
